module.exports = __webpack_public_path__ + "static/media/2.fec4bfde.png";